export function shrink(
  input: string,
  headLength: number = 5,
  tailLength: number = 5
) {
  return input
    ? `${input.slice(0, headLength)}…${input.slice(-tailLength)}`
    : "";
}
